import { useEffect, useRef, useState } from 'react';
import { EventSourcePolyfill } from 'event-source-polyfill';
import { getServiceVal } from "@/utils/cookies";
import taskListener from '@/utils/taskListener';

// 定义消息类型
export type MessageType = Array<{
  role: 'user' | 'assistant';
  content: string;
}>;

const useSSEFetch = () => {
  const [isStreaming, setIsStreaming] = useState(false);
  // signalRef 是“通知机制”，eventSourceRef 是“操作对象”，两者职责不同，不能相互替代，必须同时保留。
  // AbortController 就像是遥控器的“红色按钮”   eventSource 就像是正在播放的电视
  // 如果你按下遥控器上的按钮（abort()），只是发出“我要关机”的信号， 👉 你还得手动去关闭电视（eventSource.close()）才会真正停下来
  const signalRef = useRef<AbortController | null>(null); // 用于控制中止流请求
  const eventSourceRef = useRef<EventSourcePolyfill | null>(null); // 保存 SSE 实例

  useEffect(() => {
    // 组件卸载时清理流定时器及流任务
    return () => {
      abortRequest();
      taskListener.clearTask();
      taskListener.clearTimer();
    };
  }, []);

  // 启动流式请求
  const startStreamRequest = (query: string, onMessageReceived: (newChunk: any) => void ) => {
    const controller = new AbortController();
    signalRef.current = controller;
    const signal = controller.signal;

    const url = `/community-api/community/AIChat/v1/chat/stream?query=${encodeURIComponent(query)}`;
    const eventSource = new EventSourcePolyfill(url, {
      headers: {
        Authorization: getServiceVal("Authorization") || ""
      },
      heartbeatTimeout: 60 * 1000, // 可选：设置心跳超时时间
      withCredentials: false,
    });
    eventSourceRef.current = eventSource;


    
    eventSource.onmessage = (event) => {
      const messageHandle=()=>{
        try {
        setIsStreaming(true);
        taskListener.changeIsTasking(true);
        const data = JSON.parse(event.data);

        // 处理返回的流数据
        if (data.event === 'message') {
          const chunk = data.answer;
          onMessageReceived(chunk);
        }

        if (data.event === 'message_end') {
          // 流结束时的处理
          setIsStreaming(false);
          window.message.success('回答完成');
          taskListener.changeIsTasking(false);

          
          abortRequest(); // 结束流请求 
        }
      } catch (error) {
        // window.message.error('解析错误');
        setIsStreaming(false);
        taskListener.changeIsTasking(false);
      }
      }
      taskListener.addTask(messageHandle);

      if(!taskListener.isTasking){
        taskListener.changeIsTasking(true);
        //开启任务处理
        taskListener.startTask(64);
      }
    };

    eventSource.onerror = () => {
      // window.message.error(`请求失败`);
      setIsStreaming(false);
      taskListener.changeIsTasking(false);
    };

    eventSource.onopen = () => {
      setIsStreaming(true);
    };

    signal.addEventListener('abort', () => {
      if (eventSourceRef.current) {
        eventSourceRef.current.close();
        eventSourceRef.current = null;
      }
      setIsStreaming(false);
      taskListener.changeIsTasking(false);
      taskListener.clearTask();
      taskListener.clearTimer();
      // window.message.info('回答已被中止');
    });
  };

  // 停止流式请求
  const abortRequest = () => {
    setIsStreaming(false)
    taskListener.changeIsTasking(false);
    
    if (eventSourceRef.current) {
      eventSourceRef.current.close();
      eventSourceRef.current = null;
    }

    if (signalRef.current) {
      signalRef.current.abort();
      signalRef.current = null;
    }


  };

  return {
    startStreamRequest,
    abortRequest,
    isStreaming,
  };
};

export default useSSEFetch;
